// BrimLight/client/mainLayout.js


export default {
    defaultRoute: '/entry',
    defaultRoutes: {
        public: '/entry/login',
        appUser: '/user/dashboard',
        appAdmin: '/admin/dashboard',
        login: '/entry/login',
        entry: '/entry',
    },
    layers: {
        base: {
            template: `
                <div id="root-container-wrapper" class="vh-100">
                    <div id="dev-tools-container"></div>
                    <div id="brimlight-assistant-container"></div>
                </div>`,
            components: [
                { name: 'entry-layer', type: 'layer', layer: 'entry', container: 'root-container-wrapper' },
                { name: 'app-layer', type: 'layer', layer: 'app', container: 'root-container-wrapper' },
                { name: 'error-layer', type: 'layer', layer: 'error', container: 'root-container-wrapper' },
                { name: 'devtools', type: 'DevTools', container: 'dev-tools-container' },
                { name: 'payment-gateway', type: 'PaymentGatewayComponent', container: 'root-container-wrapper' },
                { name: 'remote-desktop-viewer', type: 'RemoteDesktopViewer', container: 'root-container-wrapper', instanceId: 'brimLightRdv' },

            ]
        },
        entry: {
            route: '/entry',
            template: `
                <div class="ab-entry-page">
                    <div id="entry-titlebar-controls" class="electron-only-titlebar-host w-100 d-flex justify-content-end pe-2" style="position: absolute; top: 0; left: 0; height: 48px; -webkit-app-region: drag; z-index: 9999;">
                        <div id="entry-titlebar-controls-target" class="h-100" style="-webkit-app-region: no-drag;"></div>
                    </div>
                    <div class="ab-entry-branding">
                        <div id="entry-branding-logo" class="mb-4"></div>
                        <h1 class="ab-entry-headline" data-i18n="Go from Idea to Video, Instantly.">Go from Idea to Video, Instantly.</h1>
                        <p class="ab-entry-subline" data-i18n="BrimLight is your AI co-pilot for video creation. Describe your vision, and watch as our AI builds the story, generates the visuals, and assembles your video in minutes. No complex software, just pure creativity.">BrimLight is your AI co-pilot for video creation. Describe your vision, and watch as our AI builds the story, generates the visuals, and assembles your video in minutes. No complex software, just pure creativity.</p>
                        <ul class="ab-entry-features">
                            <li>
                                <i class="bi bi-magic"></i>
                                <div><strong data-i18n="AI Story Engine">AI Story Engine</strong><br><span data-i18n="Describe your idea and our AI generates a complete script and storyboard.">Describe your idea and our AI generates a complete script and storyboard.</span></div>
                            </li>
                            <li>
                                <i class="bi bi-person-video3"></i>
                                <div><strong data-i18n="Consistent Characters">Consistent Characters</strong><br><span data-i18n="Create unique characters and worlds that stay consistent in every scene.">Create unique characters and worlds that stay consistent in every scene.</span></div>
                            </li>
                            <li>
                                <i class="bi bi-diamond-fill"></i>
                                <div><strong data-i18n="Full Creative Control">Full Creative Control</strong><br><span data-i18n="Fine-tune every detail with our intuitive timeline editor. You always have the final say.">Fine-tune every detail with our intuitive timeline editor. You always have the final say.</span></div>
                            </li>
                        </ul>
                    </div>
                    <div class="ab-entry-card-container">
                        <div class="ab-entry-card">
                            <div id="entry-mobile-logo" class="ab-entry-mobile-logo"></div>
                            <div id="entry-component-target"></div>
                            <div class="ab-entry-card-footer">
                                <a href="/entry/login" data-i18n="Login">Login</a>
                                <span>·</span>
                                <a href="/entry/signup" data-i18n="Sign Up">Sign Up</a>
                                <span>·</span>
                                <a href="/entry/forgot-password" data-i18n="Forgot Password">Forgot Password</a>
                            </div>
                        </div>
                    </div>
                    <div class="ab-entry-terms">
                        <span>By continuing, you agree to our <a href="/terms">Terms of Service</a> and <a href="/privacy">Privacy Policy</a>.</span>
                    </div>
                </div>
            `,
            components: [
                { name: 'branding-logo', type: 'LogoComponent', container: 'entry-branding-logo', props: { desktopLogoUrl: '/logo.png', desktopImageHeight: '40px', logoText: 'BrimLight' } },
                { name: 'mobile-logo', type: 'LogoComponent', container: 'entry-mobile-logo', props: { desktopLogoUrl: '/logo.png', desktopImageHeight: '40px', logoText: 'BrimLight' } },
                { name: 'titlebar-controls-entry', type: 'TitleBarControls', container: 'entry-titlebar-controls-target' },
                { name: 'login-layer', type: 'layer', layer: 'login', container: 'entry-component-target', default: true },
                { name: 'signup-layer', type: 'layer', layer: 'signup', container: 'entry-component-target' },
                { name: 'forgotpassword-layer', type: 'layer', layer: 'forgotpassword', container: 'entry-component-target' }
            ]
        },

        login: { route: '/entry/login', template: `<div id="login-target"></div>`, components: [{ name: 'login-comp', type: 'Login', container: 'login-target' }] },
        signup: { route: '/entry/signup', template: `<div id="signup-target"></div>`, components: [{ name: 'signup-comp', type: 'Signup', container: 'signup-target' }] },
        forgotpassword: { route: '/entry/forgot-password', template: `<div id="forgot-target"></div>`, components: [{ name: 'forgot-comp', type: 'ForgotPassword', container: 'forgot-target' }] },

        app: {
            route: '/(user|admin)',
            template: `
                <div class="d-flex flex-column h-100">
                    <header id="main-header" class="app-header"></header>
                    <main id="main-content-area" class="d-flex flex-grow-1 overflow-hidden"></main>
                </div>
            `,
            components: [
                { name: 'shared-header-layer', type: 'layer', layer: 'shared-header', container: 'main-header' },
                { name: 'user-section-layer', type: 'layer', layer: 'user-section', container: 'main-content-area' },
                { name: 'admin-section-layer', type: 'layer', layer: 'admin-section', container: 'main-content-area' },
            ]
        },
        "shared-header": {
            template: `
                <nav class="navbar navbar-expand shadow-sm h-100" style="-webkit-app-region: drag;">
                    <div class="container-fluid">
                        <div id="logo-container" style="-webkit-app-region: no-drag;"></div>
                        <div id="project-selector-container" class="ms-3" style="-webkit-app-region: no-drag;"></div>
                        <div class="ms-auto d-flex align-items-center gap-2 h-100" style="-webkit-app-region: no-drag;">
                            <div id="web-automation-btn-container"></div>
                            <div id="brimlight-assistant-container"></div>
                            <div id="checkpoint-manager-container"></div>
                            <div id="media-manager-btn-container"></div>
                            <div id="role-switcher-container"></div>
                            <div id="notifications-container"></div>
                            <div id="documentation-link-container"></div>
                            <div id="user-profile-menu-container"></div>
                            <div id="common-titlebar-controls" class="electron-only-titlebar-host h-100 ms-2"></div>
                        </div>
                    </div>
                </nav>
            `,
            components: [
                {
                    name: 'logo', type: 'LogoComponent', container: 'logo-container',
                    props: {
                        desktopLogoUrl: '/public/logo.png',
                        mobileLogoUrl: '/public/android-chrome-192x192.png',
                        desktopImageHeight: '40px'
                    }
                },
                { name: 'project-selector', type: 'ProjectSelector', container: 'project-selector-container' },
                { name: 'media-manager-button', type: 'MediaManagerButton', container: 'media-manager-btn-container' },
                { name: 'brimlight-assistant', type: 'BrimLightAssistant', container: 'brimlight-assistant-container', props: { buttonClasses: "btn btn-outline-primary btn-sm" } },
                { name: 'checkpoint-manager', type: 'CheckpointManager', container: 'checkpoint-manager-container' },
                { name: 'role-switcher', type: 'RoleSwitcher', container: 'role-switcher-container', props: { hideFor: ['appUser'] } },
                { name: 'notifications', type: 'Notifications', container: 'notifications-container' },
                { name: 'documentation-link', type: 'DocumentationLink', container: 'documentation-link-container' },
                { name: 'common-user-menu', type: 'UserProfileMenu', container: 'user-profile-menu-container', instanceId: 'userProfileMenu', props: { showThemeSelector: true, showRemoteDesktop: true, menuItems: [{ title: "Profile", route: "/user/profile" }] } },
                { name: 'titlebar-controls', type: 'TitleBarControls', container: 'common-titlebar-controls' },
            ]
        },

        "user-section": {
            route: '/user',
            template: `
                <div class="d-flex flex-column flex-md-row h-100 w-100">
                    <aside id="user-sidebar" class="app-sidebar"></aside>
                    <main id="user-content" class="flex-grow-1 overflow-auto p-1"></main>
                    <nav id="user-bottom-nav" class="app-bottom-nav"></nav>
                </div>
            `,
            components: [
                {
                    name: 'user-menu', type: 'AppMenu', container: 'user-sidebar', props: {
                        instanceid: 'user-menu',
                        startingRoute: '/user/',
                        layout: 'auto',
                        mobileContainer: 'user-bottom-nav',
                        mobileBehavior: 'bottom',
                        fullHeight: true,
                        collapsible: true,
                        defaultCollapsed: true,
                        saveState: true
                    }
                },
                { name: 'user-content-router', type: 'layer', layer: 'user-content', container: 'user-content' },
            ]
        },
        "user-content": {
            template: `<div id="user-feature-area" class="h-100"></div>`,
            components: [
                { name: 'user-dashboard-layer', type: 'layer', layer: 'user-dashboard-layer', container: 'user-feature-area', default: true },
                { name: 'user-assets-layer', type: 'layer', layer: 'user-assets-layer', container: 'user-feature-area' },
                { name: 'user-editor-layer', type: 'layer', layer: 'user-editor-layer', container: 'user-feature-area' },
                { name: 'user-profile-layer', type: 'layer', layer: 'user-profile-layer', container: 'user-feature-area' },
                { name: 'user-billing-layer', type: 'layer', layer: 'user-billing-layer', container: 'user-feature-area' },
            ]
        },
      'user-dashboard-layer': {
            route: '/user/dashboard', 
            menuItem: true, 
            menuTitle: 'Dashboard', 
            menuIcon: 'bi-grid-1x2-fill', 
            menuOrder: 1,
            template: '<div id="user-dashboard-content" class="h-100"></div>',
            components: [{
                name: 'user-dashboard', 
                type: 'UserDashboard', // <--- CHANGED from 'Dashboard'
                container: 'user-dashboard-content', 
                instanceId: "user-dashboard" 
                // Props are no longer needed here as UserDashboard handles the layout internally
            }]
        },
        'user-assets-layer': {
            route: '/user/assets', menuItem: true, menuTitle: 'Assets', menuIcon: 'bi-collection-fill', menuOrder: 2,
            template: `
                <div class="container-fluid pt-3">
                    <ul class="nav nav-tabs" id="assetTabs" role="tablist">
                        <li class="nav-item" role="presentation"><button class="nav-link" data-bs-toggle="tab" data-bs-target="#series-pane" type="button">Series</button></li>
                        <li class="nav-item" role="presentation"><button class="nav-link active" data-bs-toggle="tab" data-bs-target="#characters-pane" type="button">Characters</button></li>
                        <li class="nav-item" role="presentation"><button class="nav-link" data-bs-toggle="tab" data-bs-target="#environments-pane" type="button">Environments</button></li>
                        <li class="nav-item" role="presentation"><button class="nav-link" data-bs-toggle="tab" data-bs-target="#props-pane" type="button">Props</button></li>
                    </ul>
                    <div class="tab-content pt-3" id="assetTabContent">
                        <div class="tab-pane fade" id="series-pane" role="tabpanel"><div id="series-editor-target"></div></div> <!-- ADD THIS LINE -->
                        <div class="tab-pane fade show active" id="characters-pane" role="tabpanel"><div id="character-editor-target"></div></div>
                        <div class="tab-pane fade" id="environments-pane" role="tabpanel"><div id="environment-editor-target"></div></div>
                        <div class="tab-pane fade" id="props-pane" role="tabpanel"><div id="prop-editor-target"></div></div>
                    </div>
                </div>`,
            components: [
                { name: 'series-editor', type: 'SeriesEditor', container: 'series-editor-target' }, // ADD THIS LINE
                { name: 'character-editor', type: 'CharacterEditor', container: 'character-editor-target' },
                { name: 'environment-editor', type: 'EnvironmentEditor', container: 'environment-editor-target' },
                { name: 'prop-editor', type: 'PropEditor', container: 'prop-editor-target' },
            ]

        },



        'user-editor-layer': {
            route: '/user/editor', menuItem: true, menuTitle: 'Editor', menuIcon: 'bi-kanban-fill', menuOrder: 5,
            template: '<div id="user-video-editor-content" class="h-100"></div>',
            components: [{ name: 'video-editor', type: 'VideoEditor', container: 'user-video-editor-content' }]
        },


        'user-profile-layer': {
            route: '/user/profile', hideInMenu: true,
            template: '<div id="user-profile-content" class="h-100"></div>',
            components: [{ name: 'user-profile', type: 'UserProfile', container: 'user-profile-content' }]
        },

        'user-billing-layer': {
            route: '/user/billing',
            menuItem: true,
            menuTitle: 'Billing',
            menuIcon: 'bi-wallet-fill',
            menuOrder: 3,
            template: '<div id="user-billing-content" class="h-100"></div>',
            components: [{ name: 'billing-view', type: 'BillingView', container: 'user-billing-content' }]
        },

        "admin-section": {
            route: '/admin',
            template: `
                <div class="d-flex h-100 w-100">
                    <nav id="admin-sidebar" class="app-sidebar"></nav>
                    <div id="admin-content" class="flex-grow-1 p-1 overflow-auto"></div>
                </div>
            `,
            components: [
                { name: 'admin-menu', type: 'AppMenu', container: 'admin-sidebar', instanceId: 'admin-menu', props: { startingRoute: '/admin/', fullHeight: true, collapsible: true, defaultCollapsed: true, saveState: true } },
                { name: 'admin-content-router', type: 'layer', layer: 'admin-content', container: 'admin-content' },
            ]
        },
        "admin-content": {
            template: `<div id="admin-feature-area" class="h-100"></div>`,
            components: [
                { name: 'admin-dashboard-layer', type: 'layer', layer: 'admin-dashboard-layer', container: 'admin-feature-area', default: true },
                { name: 'admin-users-layer', type: 'layer', layer: 'admin-users-layer', container: 'admin-feature-area' },
            ]
        },
        'admin-dashboard-layer': {
            route: '/admin/dashboard', menuItem: true, menuTitle: 'Dashboard', menuIcon: 'bi-speedometer2', menuOrder: 1,
            template: '<div id="admin-dashboard-content" class="h-100"></div>',
            components: [{ name: 'admin-dashboard', type: 'Dashboard', instanceId: 'admin-dashboard', container: 'admin-dashboard-content' }]
        },
        'admin-users-layer': {
            route: '/admin/users', menuItem: true, menuTitle: 'Users', menuIcon: 'bi-people-fill', menuOrder: 2,
            template: '<div id="admin-users-content" class="h-100"></div>',
            components: [{ name: 'user-manager', type: 'UserManager', container: 'admin-users-content' }]
        },
    }
};